export const seoPathname = "/[...dynamicSEO]";